import { render, staticRenderFns } from "./Detalle_Cuenta.vue?vue&type=template&id=1be7049e"
import script from "./Detalle_Cuenta.vue?vue&type=script&lang=js"
export * from "./Detalle_Cuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports